<div class="container">
    <div class="text-center hidden-scrollbar">
        <h3>We searched the system... but found no {{whatIsMissing}}</h3>
        <img src="/assets/images/empty-list.gif">
    </div>
</div>